var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperPlane1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.481,
    height: 16.752,
    viewBox: "0 0 17.481 16.752",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paper-plane_1_",
    "data-name": "paper-plane (1)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16432",
    "data-name": "Path 16432",
    d: "M8.75,17.612V20.99a.546.546,0,0,0,.986.323l1.976-2.689Z",
    transform: "translate(-2.377 -4.784)",
    fill: "#003a6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16433",
    "data-name": "Path 16433",
    d: "M17.251.1a.546.546,0,0,0-.57-.039L.294,8.62a.546.546,0,0,0,.076,1l4.556,1.557,9.7-8.3L7.12,11.928l7.635,2.61a.559.559,0,0,0,.176.029.546.546,0,0,0,.54-.465l2-13.475A.547.547,0,0,0,17.251.1Z",
    transform: "translate(0 0)",
    fill: "#003a6f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane1);
export default __webpack_public_path__ + "static/media/paper-plane (1).78353d14ab7f3b94bdd3edb31a0a2453.svg";
export { ForwardRef as ReactComponent };